import React from "react";
import styles from "./index.module.scss";
import Apps from "../../../../icons/apps";
import Operation from "../../../../icons/operation";
import Database from "../../../../icons/database";
import Javascript from "../../../../icons/javascript";
import classes from "classnames";

export interface ButtonProps {
  onClick?: () => void;
  iconName?: "apps" | "operation" | "database" | "javascript";
  active?: boolean;
  children?: React.ReactNode;
  width?: number;
  className?: string;
}

const Button = ({
  iconName,
  children,
  width,
  onClick,
  className,
  active,
}: ButtonProps) => {
  const renderIcon = () => {
    if (iconName === "apps") {
      return <Apps />;
    }
    if (iconName === "operation") {
      return <Operation />;
    }
    if (iconName === "database") {
      return <Database />;
    }
    if (iconName === "javascript") {
      return <Javascript />;
    }
    return null;
  };
  return (
    <div
      className={classes(styles.button, active && styles.active, className)}
      onClick={onClick}
      style={{ minWidth: width }}
    >
      {iconName && <div className={styles.icon}>{renderIcon()}</div>}
      <div className={styles.text}>{children}</div>
    </div>
  );
};

export default Button;
